// extracted by mini-css-extract-plugin
export default {"SamplePaymentModal":"SamplePaymentModal_SamplePaymentModal__gAlo5"};